import { ApiResponseError } from '../ApiResponseError';
import { FinApiVerificationAttempt } from './model/FinApiVerificationAttempt';
import { FinApiVerificationRedirectionUrl } from './model/FinApiVerificationRedirectionUrl';
import { FinApiStatus } from './model/FinApiStatus';

export const postFinApiVerificationAttempt = async (
  verificationAttempt: FinApiVerificationAttempt,
): Promise<FinApiVerificationRedirectionUrl> => {
  const options: RequestInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(verificationAttempt),
    credentials: 'include',
  };

  const endpoint = `${process.env.FIN_API_SERVICE_BASE_URL}/api/verification-attempt`;

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as FinApiVerificationRedirectionUrl;
};

export const postFinApiVerificationAttemptLightRegisteredUser = async (
  verificationAttempt: FinApiVerificationAttempt,
  userId: string,
): Promise<FinApiVerificationRedirectionUrl> => {
  const options: RequestInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${userId}`,
    },
    body: JSON.stringify(verificationAttempt),
    credentials: 'include',
  };

  const endpoint = `${process.env.FIN_API_SERVICE_BASE_URL}/light-user/api/verification-attempt`;

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as FinApiVerificationRedirectionUrl;
};

export const getFinapiVerificationStatus = async (sessionId: string): Promise<FinApiStatus> => {
  const options: RequestInit = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  };

  const endpoint = `${process.env.FIN_API_SERVICE_BASE_URL}/api/user/verification/${sessionId}`;

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as FinApiStatus;
};

export const getFinapiVerificationStatusLightRegisteredUser = async (
  sessionId: string,
  userId: string,
): Promise<FinApiStatus> => {
  const options: RequestInit = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${userId}`,
    },
    credentials: 'include',
  };

  const endpoint = `${process.env.FIN_API_SERVICE_BASE_URL}/light-user/api/verification/${sessionId}`;

  const response = await fetch(endpoint, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as FinApiStatus;
};
